export function  formatDecimal(num, decimal) {
    num = num.toString()
    let index = num.indexOf('.')
    if (index !== -1) {
        num = num.substring(0, decimal + index + 1)
    } else {
        num = num.substring(0)
    }
    // console.log('parseFloat(num).toFixed(decimal)',Number(parseFloat(num).toFixed(decimal)).toLocaleString())
    return parseFloat(num).toFixed(decimal)
}


export function formatNumberAndCurrency(string, currency) {
    return formatNum(string, decimalPointCount(currency))
}

function decimalPointCount(currency) { 
    if (isDecimal(currency)) {
        return 2
    }
    return 8
}

export  function isDecimal(currency) { 
    if (currency == 'SGD' || currency == 'USD' || currency == 'EUR') {
        return true
    }
    return false
}

export function formatNum(str,decimal) {
    if(str == '' || str == null){
        str = 0
    }
    var str = str.toString()
    var prefix = ''
    for(var i = 0;i < str.length;i++){
        let subStr = str.substring(0, i + 1)
        if(!containsNumber(subStr)){
            prefix = subStr
        }else{
            break
        }
    }
    var changeStr = str.substring(prefix.length, str.length)
    let resStr = formatStr(changeStr,decimal)
    return prefix + resStr;
}

function containsNumber(str) {
    for(var i=0;i<10;i++){
        if(str.indexOf(i)!=-1){
            return true;
        }
    }
    return false;
}

export function formatStr(str,decimal) {
    var newStr = "";
    var count = 0;
    var str = str.toString()
    let index = str.indexOf('.')
    if(index !== -1){
        str = parseFloat(str.substring(0, decimal + index + 1)).toFixed(decimal)
    }else{
        str = parseFloat(str).toFixed(decimal)
    }
    for(var i = str.indexOf(".")-1;i>=0;i--){
        if(count % 3 == 0 && count != 0){
          newStr = str.charAt(i) + "," + newStr;
        }else{
          newStr = str.charAt(i) + newStr; //逐个字符相接起来
        }
        count++;
    }
    str = newStr + str.substr(str.indexOf("."),decimal + index + 2)
    return str;
}